import DetectableOverflow from 'react-detectable-overflow';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto auto 1fr;
  position: relative;
`;

export const Content = styled.div`
  overflow: overlay;
  overflow-x: hidden;
  height: 100%;
  padding-bottom: 10px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: 36px 40px 8px 40px;
`;

export const HeaderBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const HeaderBottomLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 16px;
  column-gap: 48px;
  margin-bottom: 32px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;
TitleContainer.displayName = 'TitleContainer';

export const TitleBack = styled.div`
  height: 22px;
  margin-right: 8px;
  cursor: pointer;
`;
TitleBack.displayName = 'TitleBack';

export const Title = styled.div`
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;

  &[data-hover='true'] {
    cursor: pointer;
  }
`;

export const Overflow = styled(DetectableOverflow)`
  color: #474d66;
  font-size: 24px;
  font-weight: 600;
`;

export const HelpWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
`;

export const HelpButton = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 10px 16px;
  width: 88px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  cursor: pointer;

  span {
    display: inline-flex;
  }
`;

export const HeaderBottomText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #304085;
`;

export const ShowMore = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
  cursor: pointer;
`;

export const ShowMoreText = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #6ea6fb;
`;

export const ShowMoreIcon = styled.div`
  height: 20px;
  margin-left: 8px;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonsGrid = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterButton = styled.button`
  border-radius: 8px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 36px;
  outline: 0;
  margin-right: 8px;
`;

export const AddButton = styled.button`
  border-radius: 8px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 36px;
  outline: 0;
`;

export const AddButtonText = styled.div`
  margin-left: 10px;
  color: #474d66;
  font-size: 14px;
`;

export const Spacing = styled.div`
  margin: 0 40px;
`;

export const Item = styled.div`
  margin: 0 40px;
  cursor: pointer;

  & + & {
    margin-top: 12px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  background: #e6e8f0;
  height: 1px;
  margin-bottom: 8px;
`;

export const Heading = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr 3fr 1fr 200px;
  grid-gap: 16px;
  padding: 12px 8px;

  &[data-isidentified='identified'] {
    padding: 12px 28px;
  }
`;

export const Direction = styled.div`
  margin-left: 8px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const ColumnName = styled.div`
  font-size: 12px;
  color: #8f95b2;
  font-weight: 500;
`;

interface ILine {
  isAccessory?: boolean;
}

export const Line = styled.div<ILine>`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr 3fr;
  grid-gap: 16px;

  & + & {
    margin-top: 12px;
  }
`;

export const ItemInner = styled.div<ILine>`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 12px;
  background: ${({ isAccessory }) => (isAccessory ? '#FDF7F4' : '#f5f7fb')};
`;

export const AssetGroupingLine = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 20px 2fr 3fr 3fr 200px 30px;
  grid-gap: 16px;
  padding: 8px 12px;
  background: #f5f7fb;
  border-radius: 8px;
  align-items: center;

  & + & {
    margin-top: 12px;
  }
`;

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface ILineText {
  limitOfLines?: number;
}

export const LineText = styled.div<ILineText>`
  color: #474d66;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

interface INoText {
  isError?: boolean;
}

export const NoText = styled.div<INoText>`
  color: ${({ isError }) => (isError ? '#D14343' : '#c1c4d6')};
  font-size: 14px;
  font-style: italic;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

interface IInputSearch {
  search?: boolean;
  clear?: boolean;
}

export const InputSearch = styled.input<IInputSearch>`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }

  ${({ search }) =>
    search &&
    css`
      padding-right: 66px;
    `}
  ${({ clear }) =>
    clear &&
    css`
      padding-right: 36px;
    `}
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
  height: 26px;
`;

export const SearchClear = styled.div`
  position: absolute;
  right: 16px;
  cursor: pointer;
`;

export const SearchButton = styled.div`
  position: absolute;
  right: 12px;
  font-size: 12px;
  color: #1371fe;
  cursor: pointer;
`;

export const MenuButton = styled.button`
  display: flex;
  height: 42px;
  width: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8dae5;
  background-color: transparent;
  border-radius: 8px;
`;
MenuButton.displayName = 'MenuButton';

export const AddedContainer = styled.div`
  display: flex;
  align-items: center;
`;
AddedContainer.displayName = 'AddedContainer';

export const AddedImg = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 12px;
  margin-right: 8px;
`;
AddedImg.displayName = 'AddedImg';

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding-top: 4px;
  height: 42px;
  width: 42px;
  background-color: transparent;
`;
FilterContainer.displayName = 'FilterContainer';

export const RunImporter = styled.button`
  background: ${({ disabled }) => (disabled ? '#6ea6fb' : '#1371fe')};
  border-radius: 8px;
  border: none;
  color: #fff;
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-weight: 500;
  font-size: 14px;
  margin-left: 8px;
`;
RunImporter.displayName = 'RunImporter';

interface ILineTextError {
  limitOfLines?: number;
}

export const LineTextError = styled.div<ILineTextError>`
  color: #d14343;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const ErrorIcon = styled.div`
  height: 20px;
  margin-right: 8px;
`;

export const LoadMore = styled.div`
  margin-top: 6px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const TabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  margin-top: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Label = styled.div`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};
`;

export const Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 18px;
  padding: 0 6px;
  background: #edeff4;
  border-radius: 4px;
  margin-left: 10px;
  font-weight: 600;
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const ItemTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  & + & {
    margin-left: 48px;
  }

  &[data-notvisible='false'] {
    display: none;
  }
`;

export const ErrorTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #faeeee;
  height: 26px;
  border: 1px solid #d14343;
  border-radius: 13px;
  padding: 0 8px;
  margin-left: 8px;
`;

export const ErrorTagText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #d14343;
  margin-left: 6px;
  white-space: nowrap;
`;

export const ErrorTagIcon = styled.div``;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const TextStatusContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const TextStatus = styled.div<ILineText>`
  color: #c1c4d6;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;
